<template>
  <div>
    <validation-observer ref="form" novalidate>
      <div>
        <section-title
          container-class="tag-badge-main-info mt-4 mb-4"
          content="I. Datos de Identificación del Participante (Parte B)"
          icon="fas fa-clipboard-list-check"
        />
        <div>
          <section-title
            class="mt-3"
            content="Propósito de la Evaluación Vocacional"
            has-line
          />
          <check-box
            v-for="item in purposeOfEvaluationOptions"
            :key="item.id"
            v-model="item.checked"
            :class="isReadOnly ? 'row-check disabled-check' : 'row-check'"
            :disabled="isReadOnly"
            :text="item.name"
          />
          <validation-provider
            v-slot="{ errors }"
            :name="`type-${purposeOfEvaluationId}-options`"
            :rules="hasOptionCheck(purposeOfEvaluationId) ? '' : 'required'"
          >
            <error
              v-if="errors[0]"
              class="pt-2"
              message="Al menos un Propósito de la Evaluación Vocacional es requerido."
              variant="no-border"
            />
          </validation-provider>
        </div>
        <div>
          <section-title
            class="mt-3"
            content="Análisis de Expediente"
            has-line
          />

          <div v-if="!isReadOnly">
            <label>Seleccione Análisis de Expediente:</label>
            <div class="row mb-3">
              <div class="col">
                <custom-drop-down
                  id="record"
                  v-model="currentRecord"
                  :class="{
                    'was-Invalidated': !currentRecord && currentRecordValidated,
                  }"
                  clearable
                  :disabled="isReadOnly"
                  fieldkey="id"
                  fieldname="name"
                  :options="availableRecords"
                  placeholder="Seleccione"
                />
                <div
                  class="student-search-alert-error d-flex items-align-center no-border"
                >
                  <div
                    v-if="!currentRecord && currentRecordValidated"
                    class="w-100 text-left text-danger"
                  >
                    <div class="d-inline">
                      <em class="fa fa-times-circle" />
                    </div>
                    <p class="text-left d-inline">
                      El campo es requerido
                    </p>
                  </div>
                </div>
              </div>
              <div v-if="isRecordOther" class="col-3">
                <custom-input
                  id="currentRecordOther"
                  v-model="currentRecordOther"
                  :class="{
                    'was-Invalidated':
                      !currentRecordOther && currentRecordValidated,
                  }"
                  :disabled="isReadOnly"
                />
                <div
                  v-if="!currentRecordOther && currentRecordValidated"
                  class="w-100 text-left text-danger"
                >
                  <div class="d-inline">
                    <em class="fa fa-times-circle" />
                  </div>
                  <p class="text-left d-inline">
                    El campo es requerido
                  </p>
                </div>
              </div>
              <div class="col">
                <action-button
                  :disabled="isReadOnly"
                  i="fas fa-plus"
                  text="Añadir"
                  variant="success mr-3 px-3"
                  @click="addRecord()"
                />
              </div>
            </div>
          </div>

          <label>Seleccionados:</label>
          <validation-provider
            v-slot="{ errors }"
            name="records"
            :rules="selectedRecords.length > 0 ? '' : 'required'"
          >
            <div class="mb-3">
              <chips-selection
                :chips-config="[]"
                :disabled="isReadOnly"
                :items="selectedRecords"
                @remove="removeRecord"
              />
            </div>
            <error
              v-if="errors[0]"
              message="Al menos un Análisis de Expediente es requerido."
              variant="no-border"
            />
          </validation-provider>
        </div>
        <div>
          <section-title
            class="mt-3"
            content="Cursos de Exploración Ocupacional "
            has-line
          />
          <label class="data-name">
            ¿El estudiante ha tomado algún curso de Exploración Ocupacional
            (CTEX/EDES)?:
          </label>

          <custom-radio
            v-if="!isReadOnly"
            v-model="model.hasTakenCourseOccupationalExploration"
            class="row"
            :disabled="isReadOnly"
            is-inline
            name="hasTakenCourseOccupationalExploration"
            :options="yesNotOptions"
          />

          <div v-else>
            {{ model.hasTakenCourseOccupationalExploration | boolText }}
          </div>

          <div v-if="model.hasTakenCourseOccupationalExploration">
            <div v-if="!isReadOnly && canAddCourse">
              <label>Seleccione Análisis de Expediente:</label>
              <div class="row mb-3">
                <div class="col">
                  <custom-drop-down
                    id="course"
                    v-model="currentCourse"
                    :class="{
                      'was-Invalidated':
                        !currentCourse && currentCourseValidated,
                    }"
                    clearable
                    :disabled="isReadOnly || isInPrivateSchool"
                    fieldkey="id"
                    fieldname="name"
                    :options="availableCourse"
                    placeholder="Seleccione"
                  />
                  <div
                    class="student-search-alert-error d-flex items-align-center no-border"
                  >
                    <div
                      v-if="!currentCourse && currentCourseValidated"
                      class="w-100 text-left text-danger"
                    >
                      <div class="d-inline">
                        <em class="fa fa-times-circle" />
                      </div>
                      <p class="text-left d-inline">
                        El campo es requerido
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="isCourseOther" class="col-3">
                  <custom-input
                    id="currentCourseOther"
                    v-model="currentCourseOther"
                    :class="{
                      'was-Invalidated':
                        !currentCourseOther && currentCourseValidated,
                    }"
                    :disabled="isReadOnly"
                  />
                  <div
                    v-if="!currentCourseOther && currentCourseValidated"
                    class="w-100 text-left text-danger"
                  >
                    <div class="d-inline">
                      <em class="fa fa-times-circle" />
                    </div>
                    <p class="text-left d-inline">
                      El campo es requerido
                    </p>
                  </div>
                </div>
                <div class="col">
                  <action-button
                    :disabled="isReadOnly"
                    i="fas fa-plus"
                    text="Añadir"
                    variant="success mr-3 px-3"
                    @click="addCourse()"
                  />
                </div>
              </div>
            </div>

            <label>Seleccionados:</label>
            <validation-provider
              v-slot="{ errors }"
              name="courses"
              :rules="selectedCourses.length > 0 ? '' : 'required'"
            >
              <div class="mb-3">
                <chips-selection
                  :chips-config="[]"
                  :disabled="isReadOnly"
                  :items="selectedCourses"
                  @remove="removeRecord"
                />
              </div>
              <error
                v-if="errors[0]"
                message="Al menos un Análisis de Expediente es requerido."
                variant="no-border"
              />
            </validation-provider>
          </div>
        </div>

        <div>
          <section-title
            class="mt-3"
            content="Métodos de Evaluación Utilizados"
            has-line
          />
          <validation-provider
            v-slot="{ errors }"
            name="type-options"
            :rules="
              hasOptionCheck(purposeOfEvaluationId, true) ? '' : 'required'
            "
          >
            <error
              v-if="errors[0]"
              class="pb-3"
              message="Al menos un Métodos de Evaluación es requerido."
              variant="no-border"
            />
            <div v-for="(type, index) in types" :key="index" class="mb-4">
              <options-panel
                :data="options(type)"
                :is-read-only="isReadOnly"
                is-vertical
                :type="type"
              />
            </div>
            <error
              v-if="errors[0]"
              message="Al menos un Métodos de Evaluación es requerido."
              variant="no-border"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
//mixins
import alertMixin from '@/mixins/alert.mixin.js';

//utils
import { copy } from '@/utils/objUtils';

//filters

//components
import { ValidationObserver } from 'vee-validate';
import SectionTitle from '@/shared/components/SectionTitle.vue';
import CheckBox from 'CheckBox';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import Error from 'custom-error';
import CustomRadio from '@/components/common/CustomRadio';

//local-components
import OptionsPanel from '../../components/OptionsPanel.vue';
import ChipsSelection from '../../components/ChipsSelection.vue';

//services
import {
  getRecords,
  getOnePartB,
} from '@/modules/vocational-evaluation/api.js';

//constants
import OptionTypes from '@/utils/constants/vocationalEvaluationOptionTypes';
const OtherRecord = 27;
const CourseMainRecord = 17;

export default {
  name: 'VocationalEducationPartB',
  components: {
    ValidationObserver,
    SectionTitle,
    CheckBox,
    OptionsPanel,
    CustomDropDown,
    ActionButton,
    CustomInput,
    ChipsSelection,
    Error,
    CustomRadio,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: [Number, String],
      default: () => null,
    },
    appointmentId: {
      type: [Number, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    initialModel: {
      type: Object,
      required: false,
      default: () => null,
    },
    keepUpdates: {
      type: Boolean,
      required: false,
    },
    isReadOnly: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    isInPrivateSchool: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  data() {
    return {
      currentRecord: null,
      currentRecordOther: null,
      currentRecordValidated: false,
      currentCourse: null,
      currentCourseOther: null,
      currentCourseValidated: false,
      records: [],
      types: [
        OptionTypes.MetodosEvaluacionUtilizados,
        OptionTypes.VocationalInterestsOccupationalPreferences,
        OptionTypes.BasicAcademicSkillsAcademicAchievement,
        OptionTypes.PerformanceBasedWorkSampleBasedEvaluation,
        OptionTypes.LearningStylesProcesses,
        OptionTypes.ComplementaryMethodsEvaluationObservation,
      ],
    };
  },
  computed: {
    availableRecords() {
      return this.records
        .filter((x) => x.id !== OtherRecord && !x.isCourse)
        .filter((x) => !this.model.records.map((y) => y.id).includes(x.id));
    },
    selectedRecords() {
      return this.model.records.filter(
        (x) => x.id !== OtherRecord && !x.isCourse
      );
    },
    selectedCourses() {
      return this.model.records.filter((x) => x.isCourse);
    },
    availableCourse() {
      return this.records
        .filter((x) => x.isCourse && x.id != CourseMainRecord)
        .filter((x) => !this.model.records.map((y) => y.id).includes(x.id));
    },
    options() {
      return (type) => {
        const options = this.model?.options?.filter((o) => o.type.id === type);
        if (!options?.length) return { title: null, options: [] };
        return {
          title: options[0].type.name,
          options: options,
        };
      };
    },
    yesNotOptions() {
      return [
        { label: 'Sí', value: true },
        { label: 'No', value: false },
      ];
    },
    hasOptionCheck() {
      return (type, exclude = false) =>
        this.model?.options
          ?.filter((o) => (exclude ? o.type.id !== type : o.type.id === type))
          .some((x) => x.checked);
    },
    purposeOfEvaluationId() {
      return OptionTypes.PropositoEvaluacionVocacional;
    },
    purposeOfEvaluationOptions() {
      return this.model?.options?.filter(
        (o) => o.type.id === OptionTypes.PropositoEvaluacionVocacional
      );
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isRecordOther() {
      return this.currentRecord?.id === OtherRecord;
    },
    isCourseOther() {
      return this.currentCourse?.id === OtherRecord;
    },
    canAddCourse() {
      if (this.isInPrivateSchool) {
        return !this.selectedCourses.some((x) => x.id === OtherRecord);
      }
      return true;
    },
    filled() {
      return this.initialModel?.filled ?? false;
    },
  },
  watch: {
    'model.hasTakenCourseOccupationalExploration'(val) {
      if (!val) {
        this.model.records = this.model.records.filter((x) => !x.isCourse);
        this.currentCourse = null;
        this.currentCourseOther = null;
        this.currentCourseValidated = false;
      } else if (this.isInPrivateSchool) {
        const base = this.records.find((x) => x.id === OtherRecord);
        this.currentCourse = base ? { ...base, name: 'Otro' } : null;
      }
    },
  },
  async mounted() {
    this.$emit('update:disabled', true);
    await Promise.all([this.get(), this.getRecords()]);
    this.$emit('update:disabled', false);
  },
  beforeDestroy() {
    this.$emit('update:initialModel', this.model);
  },
  methods: {
    setModelFrom(value) {
      const data = copy(value);
      this.model = data;
      this.$emit('update:initialModel', data);
    },
    async get() {
      if (this.keepUpdates && this.filled) {
        this.setModelFrom(this.initialModel);
        return;
      }
      const { data } = await getOnePartB({
        id: this.id,
        appointmentId: this.appointmentId,
      });
      const result = { ...data, filled: true };

      this.setModelFrom(result);
    },
    async getRecords() {
      const { data } = await getRecords();
      this.records = data;
      if (this.isInPrivateSchool) {
        const base = data.find((x) => x.id === OtherRecord);
        this.currentCourse = base ? { ...base, name: 'Otro' } : null;
      }
    },
    async validate() {
      return await this.$refs.form.validate();
    },
    async addRecord() {
      let isValid = !!this.currentRecord;
      if (this.isRecordOther) isValid = !!this.currentRecordOther?.trim();

      if (!isValid) {
        this.currentRecordValidated = true;
        this.ShowToast(
          '',
          'Debe completar correctamente la información para poder añadir el expediente.',
          'error'
        );

        return;
      }
      this.currentRecordValidated = false;

      const data = { ...this.currentRecord };
      if (this.isRecordOther) data.name = this.currentRecordOther;

      this.model.records.push(data);
      this.currentRecord = null;
      this.currentRecordOther = null;
    },
    async addCourse() {
      let isValid = !!this.currentCourse;
      if (this.isCourseOther) isValid = !!this.currentCourseOther?.trim();

      if (!isValid) {
        this.currentCourseValidated = true;
        this.ShowToast(
          '',
          'Debe completar correctamente la información para poder añadir el expediente.',
          'error'
        );

        return;
      }
      this.currentCourseValidated = false;

      const data = { ...this.currentCourse };
      if (this.isCourseOther) data.name = this.currentCourseOther;

      this.model.records.push(data);
      this.currentCourse = null;
      this.currentCourseOther = null;
    },
    removeRecord(item) {
      const index = this.model.records.findIndex((x) => x.id === item.id);
      if (index !== -1) this.model.records.splice(index, 1);
      if (this.isInPrivateSchool && item.id === OtherRecord) {
        const base = this.records.find((x) => x.id === OtherRecord);
        this.currentCourse = base ? { ...base, name: 'Otro' } : null;
        this.currentCourseOther = null;
      }
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .was-Invalidated .v-select {
  border-radius: 4px;
  border: 1px solid #ff0018;
}
.disabled-check {
  ::v-deep(.option-input:disabled:checked + label span) {
    background-color: #3f5b60 !important;
    border-color: #3f5b60 !important;
  }

  ::v-deep(.option-input:disabled:checked + label span .ic-check) {
    background-image: url('../../../../../assets/img/icon-check-white.svg') !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: 12px 12px !important;

    width: 20px !important;
    height: 20px !important;
    margin: 0 !important;
    display: block !important;
  }
  ::v-deep(.bg-white) {
    background-color: #c3c3c3 !important;
    cursor: not-allowed;
    opacity: 1;
  }
}
</style>
